import {TranslationKeyTransaction} from '../../keys'
import {TranslationResource} from '../../TranslationType'

export const TRANSLATION_TRANSACTION_ID: TranslationResource<TranslationKeyTransaction> = {
  translation: {
    'transaction:cancelTransactionModalMessage':
      'Kamu yakin ingin membatalkan transaksi ini?',
    'transaction:cartDoubleBookedDescription':
      'Selesaikan pembayaran, atau periksa riwayat transaksi.',
    'transaction:cartDoubleBookedTitle': 'Konten Sudah Dipesan',
    'transaction:checkTransaction': 'Cek Transaksi',
    'transaction:checkoutContentCollabRepost':
      'Collab Repost • Username kamu akan ditampilkan.',
    'transaction:checkoutContentPrice': 'Harga',
    'transaction:checkoutContentRepost':
      'Repost di beranda, fototree, profil akun.',
    'transaction:checkoutContentTeenNotice':
      'Posting ulang tidak diizinkan untuk akun remaja.',
    'transaction:checkoutTransactionDate': 'Tanggal Transaksi',
    'transaction:checkoutTransactionTitle': 'Detail Transaksi',
    'transaction:checkoutTransactionType': 'Jenis Transaksi',
    'transaction:checkoutWaitForHiresInfoDesc1':
      'Hi-Res akan muncul di “Koleksi” di tab “FotoYu”.',
    'transaction:checkoutWaitForHiresInfoDesc2':
      'Kamu juga dapat mengobrol dengan kreator penjual, dengan mengklik ikon pesan di bawah setiap konten yang kamu beli.',
    'transaction:checkoutWaitForHiresInfoDesc3':
      'Kreator harus mengirimkan Hi-Res dalam 48 jam, atau kamu akan menerima pengembalian dana.',
    'transaction:checkoutWaitForHiresInfoTitle': 'Mohon tunggu versi Hi-Res.',
    'transaction:checkoutUseAnotherBrowser':
      'Jika ada masalah, coba gunakan browser lain.',
    'transaction:creditCardLastFour': '(******{{number}})',
    'transaction:paymentFailedModalMessage':
      'Pembayaran tidak dapat diproses saat ini, silakan coba lagi nanti',
    'transaction:paymentIssue': 'Pembayaran bermasalah?',
    'transaction:qrisDownloadSuccess': 'QRIS diunduh.',
    'transaction:qrisInstructionContentA': '1. Unduh kode QRIS.',
    'transaction:qrisInstructionContentB':
      '2. Buka aplikasi bank / e-wallet yang mendukung pembayaran QRIS.',
    'transaction:qrisInstructionContentC':
      '3. Pindai / unggah kode QRIS yang telah diunduh.',
    'transaction:qrisInstructionContentD':
      '4. Pastikan bahwa semua informasi pembayaran sudah sesuai.',
    'transaction:qrisInstructionContentE':
      '5. Lanjutkan proses pembayaran sampai selesai.',
    'transaction:qrisInstructionTitle': 'Instruksi Pembayaran:',
    'transaction:qrisSubheader': 'Halaman ini bukan bukti pembayaran.',
    'transaction:repeatOrder': 'Ulangi Pemesanan',
  },
}
